import { Radio as ReactRadio, RadioProps } from '@a-ui/react';
import { Field, FieldProps } from 'formik';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import useClassNames, { IClassNames } from '../../hooks/classNames.hooks';

interface RadioGroupProps extends IClassNames {
  options: RadioProps[];
  name: string;
  id?: string;
  label: string;
  description?: string;
  required?: boolean;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  label,
  options,
  id,
  classNames,
  ...props
}) => {
  const { className } = useClassNames(classNames, 'a-input', 'ckp-m-radio-group');

  return (
    <div className={className} {...props}>
      <legend className="a-input__label ckp-m-check-group__label">{label}</legend>

      {options.map((option, index) => {
        const htmlId = uuidv4();

        return (
          <div key={`radio_${index} + option.value`} className="filter__radio u-margin-bottom-s">
            <Field name={name}>
              {({ field, form }: FieldProps<string>) => {
                const toggleCheckbox = () => {
                  form.setFieldValue(name, option.value);
                };

                return (
                  <ReactRadio
                    id={htmlId}
                    name={name}
                    label={option.label}
                    onChange={toggleCheckbox}
                    checked={field.value === option.value}
                  />
                );
              }}
            </Field>
          </div>
        );
      })}
    </div>
  );
};

export default RadioGroup;
